export const imageUrls = {
    logoVpass : '/img/vpos/logo/vpos.png',
    logoVpassXanh : '/img/vpos/logo/vposXanh.png',
    urlAnh : "https://web.vimass.vn/vmbank/services/media/getImage?id=",
    iconSetting : "/img/icon/icon-Setting.png",

    //trang chu
    iconBannerVpos: "img/vpos/iconTrangChu/iconBannerVpos.png",
    qrVpos: "img/vpos/iconTrangChu/QRvpos.png",
    downloadIos: "img/vpos/iconTrangChu/ios.png",
    downloadAndroid: "img/vpos/iconTrangChu/android.png",

    //phone
    img1: "img/vpos/imgPhoneVpos/1.jpg",
    img2: "img/vpos/imgPhoneVpos/2.jpg",
    img3: "img/vpos/imgPhoneVpos/3.jpg",
    img4: "img/vpos/imgPhoneVpos/4.jpg",
    img5: "img/vpos/imgPhoneVpos/5.jpg",
    img6: "img/vpos/imgPhoneVpos/6.jpg",
    img7: "img/vpos/imgPhoneVpos/7.jpg",
    img8: "img/vpos/imgPhoneVpos/8.jpg",

}